import styled from 'styled-components';

import { colors } from '@crm-framework/theme';

export const MAP_REPORT_TYPE_TO_COLOR: Record<ReportTypes, string> = {
  uploaded: colors.PRIMARY,
  warning: colors.WARNING,
  error: colors.DANGER,
};

export interface ICountProps {
  type: ReportTypes;
}

export type ReportTypes = 'uploaded' | 'warning' | 'error';

export const Count = styled.span<ICountProps>`
  margin: 0;
  font-weight: 600;
  ${({ type }) => `color: ${MAP_REPORT_TYPE_TO_COLOR[type]}`};
`;
